<script>
export default {
  methods: {
    getUpdatedFields() {
      const customer = this.$store.state.user;
      const form = this.$refs.form.fields
      const updatedFields = {};

      try {
        if (form.email !== customer.email) {
          updatedFields.email = form.email;
        }
        if (form.first_name !== customer.first_name) {
          updatedFields.first_name = form.first_name;
        }
        if (form.last_name !== customer.last_name) {
          updatedFields.last_name = form.last_name;
        }
        if (form?.company && form.company !== customer.company) {
          updatedFields.company = form.company;
        }
        if (form?.vat_id || customer?.vat_id && form.vat_id !== customer.vat_id) {
          updatedFields.vat_id = form.vat_id;
        }
        if (form?.phone_number && form.phone_number !== customer.phone_number) {
          updatedFields.phone_number = form.phone_number;
        }
        if (form.user_address !== customer.address) {
          updatedFields.address = form.user_address;
        }
        if (form.user_city !== customer.city) {
          updatedFields.city = form.user_city;
        }
        if (form?.user_state?.name && form?.user_state?.name !== customer.state) {
          updatedFields.state = form.user_state.name;
        }
        if (form?.zip && form.zip !== customer.zip) {
          updatedFields.zip = form.zip;
        }
        if (form.country.name !== customer.country) {
          updatedFields.country_id = form.country.id;
        }
        const { current_password, password, password_confirmation } = { ...this.$refs.password.fields };
        if (current_password && password && password_confirmation) {
          updatedFields.password = true;
        }
      } catch (error) {
        console.error('getUpdatedFields error', error);
      }
      return updatedFields;
    },
}
}
</script>
